var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donate"},[_c('div',{staticClass:"donate-logo"}),_c('router-link',{staticClass:"donate-button",attrs:{"to":_vm.$link('get-involved/donate')}},[_vm._v("Donate")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }